const footer = () => {
  document
    .querySelectorAll('.mrFooter-linksHeading')
    .forEach(function (element) {
      element.addEventListener('click', function () {
        const radioButton = this.previousElementSibling;
        if (radioButton.checked) {
          setTimeout(() => {
            radioButton.checked = false;
          }, 0);
        }
      });
    });
};

export default footer;
